import messageManagement from './message-management';
import noticeManagement from './notice-management'

export default {
    namespaced: true,
    modules: {
        messageManagement,
        noticeManagement
    }
};
